import { createBlueprint as e } from "@made-people/blueprint";
const l = e({
  slots: {
    base: "flex flex-col items-center justify-center gap-4 py-6 max-w-[280px] col-span-12 place-self-center",
    seenProducts: "text-body-sm",
    buttonWrapper: "flex w-full",
    progressbar: "w-full bg-background-surface-1 rounded-full overflow-hidden",
    progressbarFill: "h-2 bg-primary rounded-full"
  },
  variants: {}
});
export {
  l as loadMoreBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
